/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { UniversalTrackerValueView } from '../../../utils/universalTrackerValueView';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

interface ColumnValueProps extends ColumnCommonProps{
}

export const ColumnValue = (props: ColumnValueProps) => {
  const { question } = props;

  if (!question.utrv) {
    return null;
  }

  return (
    <Column className='valueCol'>
      <UniversalTrackerValueView
        utr={question.universalTracker}
        utrv={question.utrv}
        valueType={question.valueType}
      />
    </Column>
  );
}
